import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#800020', // Maroon
      light: '#9a1a3a',
      dark: '#600018',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#ffffff', // White
      dark: '#f8f0f1',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#800020',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h4: {
      color: '#800020',
      fontWeight: 600,
    },
    button: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            backgroundColor: 'transparent',
            opacity: 0.9,
          },
        },
        contained: {
          backgroundColor: '#800020',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: 'rgba(128, 0, 32, 0.8)',
            backdropFilter: 'blur(4px)',
          },
        },
        outlined: {
          borderColor: '#800020',
          color: '#800020',
          '&:hover': {
            backgroundColor: 'transparent',
            borderColor: '#800020',
            opacity: 0.8,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#800020',
          boxShadow: '0 2px 4px rgba(128, 0, 32, 0.1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 12px rgba(128, 0, 32, 0.1)',
          transition: 'all 0.3s ease',
        },
        elevation1: {
          '&:hover': {
            boxShadow: '0 6px 16px rgba(128, 0, 32, 0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 24px rgba(128, 0, 32, 0.15)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: 'rgba(128, 0, 32, 0.5)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#800020',
            },
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#800020',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#800020',
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
}); 